import React, { useEffect, createElement } from 'react';
export function ApplicationForm() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <section className="py-[80px] px-6 md:py-[120px] md:px-[72px] bg-surface border-t border-subdued" id="apply" data-id="element-9">
      <div className="max-w-[760px] mx-auto" data-id="element-10">
        <div className="text-center mb-16" data-id="element-11">
          <div className="inline-flex items-center justify-center gap-2.5 text-[10px] tracking-[3px] uppercase text-gold mb-5 font-medium" data-id="element-12">
            <span className="w-6 h-px bg-gold" data-id="element-13"></span>
            Aplicar Ahora
          </div>
          <h2 className="font-serif text-[clamp(36px,4vw,58px)] font-light tracking-tight mb-4 text-cream" data-id="element-14">
            Descubre si podemos
            <br data-id="element-15" />
            hacer crecer tu negocio.
          </h2>
          <p className="text-base text-muted" data-id="element-16">
            Responde algunas preguntas para que podamos entender tu situación y
            decirte exactamente cómo escalaríamos tu pipeline.
          </p>
        </div>

        <div style={{
        background: '#080808',
        border: '1px solid #2e2e2e',
        position: 'relative',
        overflow: 'hidden',
        padding: 0
      }} data-id="element-17">
          {/* Gold line top */}
          <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: 'linear-gradient(90deg, transparent, #b8973a, transparent)',
          zIndex: 10
        }} data-id="element-18" />
          {/* Gold glow */}
          <div style={{
          position: 'absolute',
          top: '-100px',
          right: '-100px',
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(184,151,58,0.05), transparent 65%)',
          pointerEvents: 'none',
          zIndex: 0
        }} data-id="element-19" />
          <iframe src="https://api.leadconnectorhq.com/widget/form/aAEorrzgnosVe4Be7Lw9" style={{
          width: '100%',
          minHeight: '700px',
          border: 'none',
          display: 'block',
          background: '#080808',
          position: 'relative',
          zIndex: 1
        }} id="ghl-form-frame" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" scrolling="no" data-id="element-20" />
        </div>
      </div>
    </section>;
}